<template>
  <tr>
    <th><b>{{ course.course.name }}</b></th>
    <td>{{ course.course.created_at }}</td>
    <td>{{ boolToText( course.course.was_approved )  }}</td>
    <td>{{ boolToText( course.course.is_sellable )  }}</td>
    <td>
      <router-link :to="urlPath" class="btn btn-sm btn-dark"><i class="fa fa-edit"></i></router-link>
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    course: {
      required: true
    }
  },
  computed: {
    urlPath: function () {
      let name = this.course.course.name.split(" ").join("-").toLowerCase()
      return `/curso/${ this.course.course.id }/${ name }/${this.course.id}/co-produtor`
    }
  },
  methods: {
    boolToText: ( value ) => { return value ? 'Sim' : 'Não' }
  }
}
</script>

<style>

</style>
